<template>
    <div class="or-admin-content" ref="content">
        <div class="slot padding-top-40" ref="slot" :style="{height: (getAdmin('show_edit') || getAdmin('show_ceil_edit') || getAdmin('show_inner_edit') || getAdmin('show_image_edit')) && $parent.selected_page === 'products' ? '68%' : '100%' }">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    computed: {
        ...mapGetters({getAdmin: 'getAdmin'}),
    }
}
</script>

<style scoped>
    .or-admin-content {
        position: absolute;
        transition-duration: 150ms;
        right: 40px;
        bottom: 50px;
        width: 870px;
        height: calc(100vh - 220px);
        border-radius: 8px;
        background-color: white;
        overflow: hidden;
    }
    .slot {
        width: 102%;
        height: 100%;
        overflow-y: scroll;
        overflow-x: hidden;
    }
</style>